import React from "react";

interface OnboardingLayoutProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  onContinue: () => void;
  canContinue?: boolean;
  step: number;
  totalSteps: number;
  buttonText?: string;
}

export default function OnboardingLayout({
  title,
  subtitle,
  children,
  onContinue,
  canContinue = true,
  step,
  totalSteps,
  buttonText = "Continue",
}: OnboardingLayoutProps) {
  return (
    <div className="flex flex-col items-center justify-between min-h-screen p-3 sm:p-6 bg-gray-50">
      <div className="flex flex-col items-start w-full max-w-md mt-4 sm:mt-10">
        <div className="mb-4 sm:mb-6 w-full bg-gray-200 rounded-full h-2.5">
          <div className="h-2.5 rounded-full bg-blue-600" style={{ width: `${(step / totalSteps) * 100}%` }}></div>
        </div>
        <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-6 w-full text-center">{title}</h2>
        {subtitle && <p className="text-gray-600 text-sm w-full">{subtitle}</p>}
      </div>

      <div className="w-full max-w-md flex-1 flex flex-col justify-center my-4 sm:my-0">{children}</div>

      <div className="w-full max-w-md mb-6 sm:mb-10 mt-4 sm:mt-0">
        <button
          onClick={onContinue}
          disabled={!canContinue}
          className={`w-full py-3 px-4 text-white font-medium rounded-lg transition-colors ${
            canContinue
              ? "bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:ring-blue-300"
              : "bg-gray-400 cursor-not-allowed"
          }`}
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
}
